<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <air-real-list config-module="223401" :is-history="true" />
  </div>
</template>

<script>

import AirRealList from '@/views/cargo/v0/Price/components/list/airRealList'
export default {
  name: 'PriceAirLog',
  components: {
    AirRealList
  }
}
</script>

<style lang="scss">
</style>
